import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { EGGCALC_GEN } from "./eggcalc_gen";

export function eggcalcSlug(lang) {
  return (EGGCALC_GEN[lang] || EGGCALC_GEN[DEFAULT_LANG] || {}).slug;
}
export function eggcalcData(lang) {
  return EGGCALC_GEN[lang] || EGGCALC_GEN[DEFAULT_LANG] || {};
}
export function eggcalcPath(lang) {
  return `${langPrefix(lang)}/${eggcalcSlug(lang)}`;
}
export function buildEggcalcAlternates(origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => eggcalcSlug(l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${eggcalcPath(l.code)}` }));
  if (eggcalcSlug(DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${eggcalcPath(DEFAULT_LANG)}` });
  return alts;
}
// { lang: slug } for the router.
export const EGGCALC_SLUGS = Object.fromEntries(LOCALES.map((l) => [l.code, eggcalcSlug(l.code)]).filter(([, s]) => s));
